import { useState } from "react";
import { clearParentToken, getParentToken, setParentToken } from "../lib/storage";

const graphData = [
  { label: "Attendance", value: 92, tone: "from-skyglow to-emerald-400" },
  { label: "Mock Accuracy", value: 81, tone: "from-sun to-emerald-400" },
  { label: "Homework", value: 88, tone: "from-slateblue to-skyglow" },
  { label: "Live Engagement", value: 76, tone: "from-signal to-sun" },
];

const childUpdates = [
  "Attendance improved for the last three weeks.",
  "Math mock score is up by 11 points month on month.",
  "Physics tutor flagged one chapter for revision this weekend.",
];

export default function ParentDashboard() {
  const [token, setToken] = useState(getParentToken());

  const handleGenerate = () => {
    const mockToken = `mock-parent-jwt.${Date.now()}`;
    setParentToken(mockToken);
    setToken(mockToken);
  };

  const handleClear = () => {
    clearParentToken();
    setToken("");
  };

  if (!token) {
    return (
      <section className="section-shell pt-16">
        <div className="surface-panel mx-auto max-w-4xl p-8 text-center">
          <div className="eyebrow-light">Mock JWT Protected Route</div>
          <h1 className="headline mt-4">Parent dashboard access</h1>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-8 text-slate-600">
            This placeholder route checks for a mock JWT in localStorage before showing progress data.
            Generate a demo token to preview attendance, mock score trends, and tutor notes.
          </p>
          <button type="button" className="button-primary mt-8" onClick={handleGenerate}>
            Generate Mock Parent JWT
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="section-shell pt-10">
      <div className="hero-stage p-8 lg:p-10">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <div className="eyebrow">Parent Dashboard</div>
            <h1 className="headline-invert mt-4">Track attendance, scores, and tutor feedback</h1>
            <p className="mt-4 max-w-2xl text-base leading-8 text-white/74">
              A parent-friendly placeholder showing how progress graphs, tutor notes, and next actions could look once this is wired to real auth and persistent storage.
            </p>
          </div>
          <button type="button" className="button-ghost" onClick={handleClear}>
            Clear Mock JWT
          </button>
        </div>
      </div>

      <div className="mt-10 grid gap-6 lg:grid-cols-[1fr_0.9fr]">
        <div className="surface-panel p-8">
          <p className="eyebrow-light">Sample Progress Graphs</p>
          <div className="mt-6 space-y-5">
            {graphData.map((item) => (
              <div key={item.label}>
                <div className="mb-2 flex items-center justify-between text-sm font-extrabold text-slate-700">
                  <span>{item.label}</span>
                  <span>{item.value}%</span>
                </div>
                <div className="h-4 overflow-hidden rounded-full bg-slate-100">
                  <div className={`h-full rounded-full bg-gradient-to-r ${item.tone}`} style={{ width: `${item.value}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <div className="surface-panel p-6">
            <h2 className="font-display text-2xl font-extrabold text-ink">Latest Parent Notes</h2>
            <ul className="mt-5 space-y-4">
              {childUpdates.map((item) => (
                <li key={item} className="soft-panel px-4 py-3 text-sm leading-7 text-slate-700">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="dark-shell p-6">
            <div className="eyebrow">Upcoming Action</div>
            <h2 className="mt-3 font-display text-3xl font-extrabold text-white">
              Mock test review with counselor tomorrow at 6:00 PM
            </h2>
            <p className="mt-4 text-sm leading-7 text-white/74">
              In production, this route can be powered by Firebase Auth JWTs or a custom backend session check.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
